import SimpleParallax from "simple-parallax-js";
import PvHeroImage from '../assets/pv_hero_image.png';
import Button from "react-bootstrap/esm/Button";
import './HeroImage.css';

const HeroImage = ({ onOpenModal }) => {
  return (
    <div className="hero-image">
      <SimpleParallax>
        <img src={PvHeroImage} alt="Cottonwood Tinting Home & Business tinting windows in a client's home" className="parallax-image" />
      </SimpleParallax>
      <div className="overlay">
        <div className="overlay-text">Design with Light<br />Live with Comfort</div>
        <Button className="hero-button" onClick={onOpenModal}>Request an Estimate</Button>
      </div>
    </div>
  );
}

export default HeroImage;